import type { ColumnDef } from "@tanstack/react-table";
import type { ICotizacion } from "../../../modelos/Cotizador/entidades/ICotizacion";
import { ActionIcon, Badge, Group, Text, Tooltip, Checkbox } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

interface IConstantesTablaCotizacionesProps {
    seleccionadas: ICotizacion[];
    manejarSeleccion: (cotizacion: ICotizacion) => void;
    manejarSeleccionMasiva: (seleccionarTodos: boolean) => void;
    aprobarCotizacion: (cotizacion: ICotizacion) => void;
    rechazarCotizacion: (cotizacion: ICotizacion) => void;
    todasSeleccionadas: boolean;
    algunasSeleccionadas: boolean;
}

export const columnasTablaCotizaciones = ({
    seleccionadas,
    manejarSeleccion,
    manejarSeleccionMasiva,
    aprobarCotizacion,
    rechazarCotizacion,
    todasSeleccionadas,
    algunasSeleccionadas
}: IConstantesTablaCotizacionesProps): ColumnDef<ICotizacion>[] => [
        {
            id: "seleccion",
            header: () => (
                <Checkbox
                    checked={todasSeleccionadas}
                    indeterminate={algunasSeleccionadas && !todasSeleccionadas}
                    onChange={(event) => manejarSeleccionMasiva(event.currentTarget.checked)}
                    size="xs"
                />
            ),
            cell: ({ row }) => (
                <Checkbox
                    checked={seleccionadas.some(c => c.Id === row.original.Id)}
                    onChange={() => manejarSeleccion(row.original)}
                    size="xs"
                    disabled={row.original.Aprobada}
                />
            ),
            size: 50,
            enableSorting: false,
            enableHiding: false,
        },
        {
            id: "actions",
            header: "Acciones",
            cell: ({ row }) => {
                const cotizacion = row.original;
                // const estaSeleccionada = seleccionadas.some(c => c.Id === cotizacion.Id);

                return (
                    <Group gap={4}>
                        {!cotizacion.Aprobada && (
                            <>
                                <Tooltip
                                    label="Aprobar"
                                    withinPortal
                                    openDelay={100}
                                    zIndex={9999}
                                    style={{ fontSize: '10px', padding: '3px 5px' }}
                                >
                                    <ActionIcon
                                        variant="subtle"
                                        color="var(--mantine-color-primary-0)"
                                        size="sm"
                                        radius="xl"
                                        onClick={() => aprobarCotizacion(cotizacion)}
                                    >
                                        <IconCheck size={14} />
                                    </ActionIcon>
                                </Tooltip>
                                <Tooltip
                                    label="Rechazar"
                                    withinPortal
                                    openDelay={100}
                                    zIndex={9999}
                                    style={{ fontSize: '10px', padding: '3px 5px' }}
                                >
                                    <ActionIcon
                                        variant="subtle"
                                        color="#df675a"
                                        size="sm"
                                        radius="xl"
                                        onClick={() => rechazarCotizacion(cotizacion)}
                                    >
                                        <IconX size={14} />
                                    </ActionIcon>
                                </Tooltip>
                            </>
                        )}
                        {cotizacion.Aprobada && (
                            <Text size="xs" c="dimmed">
                                Aprobada
                            </Text>
                        )}
                    </Group>
                );
            },
            size: 120,
        },
        {
            accessorKey: "IdSolicitud",
            header: "Número Solicitud",
        },
        {
            accessorKey: "CodigoServicio",
            header: "Código Servicio",
        },
        {
            accessorKey: "FechaCreacion",
            header: "Fecha Creación",
            cell: ({ getValue }) => {
                const fecha = getValue() as string;
                return (
                    <Text size="sm">
                        {fecha ? new Date(fecha).toLocaleDateString('es-CO') : '-'}
                    </Text>
                );
            },
        },
        {
            accessorKey: "TecnicoSolicita",
            header: "Técnico Solicita",
        },
        {
            accessorKey: "Repuesto",
            header: "Repuesto",
        },
        {
            accessorKey: "Cantidad",
            header: "Cantidad",
        },
        {
            accessorKey: "PrecioVenta",
            header: "Precio Venta",
        },
        {
            accessorKey: "FechaAprobacion",
            header: "Fecha Aprobación",
            cell: ({ row }) => {
                const fecha = row.original.FechaAprobacion;
                const aprobada = row.original.Aprobada;

                return (
                    <Group gap={8} justify="center">
                        {aprobada ? (
                            <Badge color="primary" variant="light" size="sm">
                                {fecha ? new Date(fecha).toLocaleDateString('es-CO') : 'Aprobada'}
                            </Badge>
                        ) : (
                            <Badge color="#df9a5aff" variant="light" size="sm">
                                Pendiente
                            </Badge>
                        )}
                    </Group>
                );
            },
            // size: 140,
        },

    ];
